import React, { useMemo, useState } from "react";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { Link } from "react-router-dom";
import { fourPlaceHolder, getFormattedDate } from "modules/utilities/utility";
import _ from "lodash";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import { Tag } from "antd";

function DoctorPrescriptionTable({
  dashboardData,
  dashboardLoading,
  newPage,
  page,
}) {
  const tableMappedData = useMemo(() => {
    return (dashboardData?.data || [])?.map((item) => ({
      name: _.get(item, "order.case.user.first_name", ""),
      order_id: _.get(item, "order.order_display_id", "-"),
      status: _.get(item, "order.status", "-"),
      order_created_at: getFormattedDate(_?.get(item, "order.created_at")),
      created_at: getFormattedDate(_.get(item, "created_at")),
      order_count: _.get(item, "order.count", "-"),
      order_meta: _.get(item, "order.order_meta.line_items", "-"),
      case_id: _.get(item, "order.case.id", "-"),
    }));
  }, [dashboardData?.data]);

  const columns = [
    {
      accessor: "name",
      Header: "Name",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const caseId = rowData.row.original.case_id;
        return (
          <div className="">
            <Link to={`/lead-details/${caseId}`}>
              {rowData.row.original.name}
            </Link>
          </div>
        );
      },
    },
    {
      accessor: "order_id",
      Header: "Order Id",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "order_meta",
      Header: "Order Name",
      headerProps: { className: "text-900" },
      width: 100,
      Cell: (rowData) => {
        return (
          <div className="text-wrap text-break">
            {rowData.row.original.order_meta.map((item) => {
              return (
                <span key={item}>
                  {item.name}
                  {item.quantity}/{" "}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      accessor: "New/Repeat",
      Header: "New/Repeat",
      Cell: (rowData) => {
        return (
          <div className="text-wrap text-break">
            {rowData.row.original.order_count <= 1 ? (
              <Tag color="blue">New</Tag>
            ) : (
              <Tag color="cyan">Repeat{rowData.row.original.order_count}</Tag>
            )}
          </div>
        );
      },
    },
    {
      accessor: "status",
      Header: "Status",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        return <Tag color="blue">{rowData.row.original.status}</Tag>;
      },
    },
    {
      accessor: "order_created_at",
      Header: "Order Date",
      headerProps: { className: "text-900" },
      cellProps: {
        className: "fw-medium",
      },
    },
    {
      accessor: "created_at",
      Header: "Assigned On",
      headerProps: { className: "text-900" },
      cellProps: {
        className: "fw-medium",
      },
    },
  ];

  return (
    <>
      {dashboardLoading
        ? fourPlaceHolder()
        : tableMappedData?.length && (
            <AdvanceTableWrapper columns={columns} data={tableMappedData}>
              <AdvanceTable
                table
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                  bordered: true,
                  striped: true,
                  className: "fs-10 mb-0 overflow-hidden",
                }}
              />
            </AdvanceTableWrapper>
          )}
      <PaginationDiv
        paginationData={{
          pageCount: +dashboardData?.pagination?.pageCount || 1,
          page: Number(page),
        }}
        newPage={newPage}
      />
    </>
  );
}

export default DoctorPrescriptionTable;
